import React from "react";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import Input from "Components/UI/Input";
import { Select, Table, Button } from "antd";
import { Delete, PlusCircle } from "react-feather";

import {
  PlusCircleOutlined,
  SaveOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useFormattedEmailModuleListOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "In-Active", value: false },
];

const emailFrequencyOptions = [
  { id: "D", label: "Daily", value: "Daily" },
  { id: "W", label: "Weekly", value: "Weekly" },
  { id: "M", label: "Monthly", value: "Monthly" },
];

const alertChannelOptions = [
  { id: "E", label: "Email", value: "Email" },
  { id: "S", label: "SMS", value: "SMS" },
];
const EmailAlertConfigForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const addRowHandler = () => {
    append({
      id: 0,
      alertConfigId: 0,
      emailAddress: "",
      isActive: true,
      companyCode: watch("companyCode"),
    });
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "emailAlertRecipients",
    keyName: "emailAlertRecipientsId",
  });

  const moduleOptions = useFormattedEmailModuleListOption(watch("companyCode"));
  const columns = [
    {
      title: "Email Id",
      dataIndex: "transactionId",
      width: "20%",
      render: (_, __, index) => (
        <Input
          name={`emailAlertRecipients[${index}].emailAddress`}
          type="text"
          placeholder="Email ID"
          className={`form-control ${
            errors?.emailAlertRecipients?.[index]?.emailAddress
              ? "is-invalid"
              : ""
          }`}
          style={{ width: "200px" }}
        />
      ),
    },

    {
      title: "Modules",
      dataIndex: "modules",
      width: "40%",
      render: (_, __, index) => (
        <Input
          name={`emailAlertRecipients[${index}].modules`}
          type="commonSelect"
          placeholder="Select Modules"
          className={`form-control ${
            errors?.emailAlertRecipients?.[index]?.modules ? "is-invalid" : ""
          }`}
          optionData={moduleOptions}
          mode={"multiple"}
          showSearch={true}
          allowClear={true}
          onChange={(val) =>
            setValue(`emailAlertRecipients[${index}].modules`, val)
          }
          style={{ height: "auto" }}
        />
      ),
    },

    {
      title: "Status",
      dataIndex: "isActive",
      width: 100,
      render: (_, __, index) => (
        <Input
          name={`emailAlertRecipients[${index}].isActive`}
          type="commonSelect"
          placeholder="Slect Active Status"
          className={`form-control ${
            errors?.emailAlertRecipients?.[index]?.isActive ? " is-invalid" : ""
          }`}
          label=""
          labelClassName="form-label"
          optionData={isStatusOption}
          required={false}
          requiredMessage="Active Status is required"
          onChange={(selectedOption) => {
            setValue(`emailAlertRecipients[${index}].isActive`, selectedOption);
            trigger(`emailAlertRecipients[${index}].isActive`);
          }}
          defaultValue={watch(`emailAlertRecipients?.[${index}]?.isActive`)}
        />
      ),
    },
    {
      title: "Actions",
      width: 100,
      render: (_, __, index) => (
        <Button
          icon={<DeleteOutlined />}
          type="text"
          onClick={() => remove(index)}
          danger
        />
      ),
    },
  ];

  return (
    <>
      <div className="form-row row">
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="alertFrequency"
            type="commonSelect"
            placeholder="Select Status"
            className={`form-control select ${
              errors.alertFrequency ? "is-invalid" : ""
            }`}
            label="Alert Frequency"
            labelClassName="form-label"
            optionData={emailFrequencyOptions}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue("alertFrequency", selectedOption);
              trigger("alertFrequency");
            }}
            defaultValue={watch("alertFrequency")}
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="noofDays"
            type="number"
            placeholder="No of Days"
            className={`form-control ${errors.noofDays ? "is-invalid" : ""}`}
            label="No of Days"
            labelClassName="form-label"
            required={true}
            requiredMessage="No of Days is required"
            defaultValue={watch("noofDays")}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="alertChannel"
            type="commonSelect"
            placeholder="Select Status"
            className={`form-control select ${
              errors.alertChannel ? "is-invalid" : ""
            }`}
            label="Alert Channel"
            labelClassName="form-label"
            optionData={alertChannelOptions}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue("alertChannel", selectedOption);
              trigger("alertChannel");
            }}
            defaultValue={watch("alertChannel")}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name="isActive"
            type="commonSelect"
            placeholder="Select Status"
            className={`form-control select ${
              errors.isActive ? "is-invalid" : ""
            }`}
            label="Status"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue("isActive", selectedOption);
              trigger("isActive");
            }}
            defaultValue={watch("isActive")}
          />
        </div>
      </div>
      {watch("alertChannel") === "Email" ? (
        <>
          <div className="d-flex justify-content-between mt-5 mb-2">
            <h4 className="card-title">Email Alert Recipients</h4>
            <button
              type="button"
              className="btn btn-success rounded-pill btn-sm"
              onClick={addRowHandler}
            >
              <PlusCircle className="me-2" />
              Add Row
            </button>
          </div>
          <div className="table-list-card">
            <div className="">
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={fields}
                  pagination={false}
                  rowKey="id"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default EmailAlertConfigForm;
